import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { SALES_CHANNELS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

// Async thunk for fetching tokens
export const getTokens = createAsyncThunk('connectedTokens/getTokens', async (_, { rejectWithValue }) => {
	try {
		const axiosPrivate = useAxiosPrivate();
		const response = await axiosPrivate.post(SALES_CHANNELS.GET_SALES_CHANNEL_OTO_API);
		if (response.status === 200) {
			return response.data?.reverse() || [];
		} else {
			AppLogger.error('Failed to fetch tokens', response);
			return rejectWithValue('Failed to fetch tokens');
		}
	} catch (error) {
		AppLogger.error(error);
		return rejectWithValue(error);
	}
});

const connectedTokensSlice = createSlice({
	name: 'connectedTokens',
	initialState: {
		data: [],
		loading: false,
		error: null
	},
	reducers: {
		setConnectedTokens: (state, { payload }) => {
			state.data = [...payload];
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(getTokens.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getTokens.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload;
			})
			.addCase(getTokens.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	}
});

export const { setConnectedTokens } = connectedTokensSlice.actions;
export default connectedTokensSlice.reducer;
